import { WorkingPasscodeList } from '../components/admin/create/registration/passcode-list';
import { PasscodeListMember } from '../types/working-model';
import { Put, Get, Post, Delete } from './helpers';

export const GetPasscodeLists = async (channel: number, token: string): Promise<any> => {
	return Get(`/v3/admin/content/passcode-lists/${channel}`, token, {}, true)
		.then(async res => {
			if (res.ok) {
				return await res.json();
			}

			return { error: res.status };
		}).catch(e => ({ error: e }));
};

export const CreateNewPasscodeList = async (token: string, channel: number, passcode_list: WorkingPasscodeList): Promise<any> => {
	if (passcode_list.url === '') {
		Post('/v3/admin/content/passcode-lists/no-members', token, { ...passcode_list, channel: channel }, false, {}, true)
			.then(async res => {
				if (res.ok) {
					return await res.json();
				}

				return { error: res.status };
			}).catch(e => ({ error: e }));
	}
	else {
		return Post('/v3/admin/content/passcode-lists', token, { ...passcode_list, channel: channel }, false, {}, true)
			.then(async res => {
				if (res.ok) {
					return await res.json();
				}

				return { error: res.status };
			}).catch(e => ({ error: e }));
	}
};

export function UpdateMaxUses(
	token: string,
	uses: number,
	list: number | undefined
): Promise<any> {
	if (list) {
		return Put(
			`/v3/admin/content/passcode-lists/update-list/max-uses`,
			token,
			{
				uses,
				list,
			}
		);
	}
	else { return Promise.resolve(); }
}

export function UpdateMasterPasscode(
	token: string,
	passcode: string,
	list: number | undefined
): Promise<any> {
	if (list) {
		return Put(
			`/v3/admin/content/passcode-lists/update-list/master-passcode`,
			token,
			{ passcode, list }
		);
	}
	else { return Promise.resolve(); }
}

export const UploadMembers = async (token: string, channel: number, filename: string, passcode_list: number, type: number, url: string): Promise<any> => {
	return Post('/v3/admin/content/passcode-lists/members', token, { filename, passcode_list, type, url, channel }, false, {}, true)
		.then(async res => {
			if (res.ok) {
				return await res.json();
			}

			return { error: res.status };
		}).catch(e => ({ error: e }));
};

export const DeleteMembers = async (members: PasscodeListMember[], token: string): Promise<any> => {
	const membersToDelete: number[] = members.map((member) => member.passcode_list_member);

	return Delete('/v3/admin/content/passcode-lists/removemember', token, { passcodeListMembers: membersToDelete }, false, true)
		.then(async res => {
			if (res.ok) {
				return await res.json();
			}

			return { error: res.status };
		}).catch(e => ({ error: e }));
};